import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.75 11.25H2.25v10.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5Zm0-4.5H2.25a1.5 1.5 0 0 0-1.5 1.5v2.25a.75.75 0 0 0 .75.75h21a.75.75 0 0 0 .75-.75V8.25a1.5 1.5 0 0 0-1.5-1.5m-10.5 0c-3.314 0-6.75-2.686-6.75-6"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.5.75c3.314 0 6.75 2.686 6.75 6m1.5 0c3.314 0 6.75-2.686 6.75-6"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5.75c-3.314 0-6.75 2.686-6.75 6m-3 0h4.5v16.5h-4.5z"
    }, null, -1)
  ]));
}
const shoppingGiftPresent = { render };
export {
  shoppingGiftPresent as default,
  render
};
//# sourceMappingURL=shopping-gift-present.svg.js.map
